<template>
  <div v-if="recipe" class="article-of-the-day-container mt-4 mb-4">
    <!-- Title for the main article -->
    <div v-if="!id || id === '0'">
      <hr />

      <div v-if="articletype === 'article'">
        <h2>История дня <i class="bi bi-book-half text-warning"></i></h2>
        <div class="text-secondary small mt-n2 mb-4">
          История одного рецепта. Приятного аппетита!
        </div>
      </div>

      <div v-else-if="articletype === 'recipe_of_the_day'">
        <h2>Рецепт дня <i class="bi bi-star-fill text-warning"></i></h2>
        <div class="text-secondary small mt-n2 mb-4">
          Наше специальное предложение на сегодня. Едим вместе!
        </div>
      </div>
    </div>

    <!-- Main article card -->
    <RecipeCardPopular
      class="mt-2"
      :recipe="recipe"
      @show-full-recipe="handleShowFullRecipe"
    />

    <!-- Display the post text from the database -->
    <div
      v-if="recipe.posttext"
      v-html="formattedPostText"
      class="mt-3 mb-3"
    ></div>

    <!-- Similar articles section -->
    <SimilarArticles
      v-if="recipe"
      :articletype="recipe.articletype"
      :exclude-id="recipe.id"
    />
  </div>

  <div v-else-if="isLoading" class="text-center mt-4 mb-4">
    <span class="visually-hidden">Загрузка...</span>
  </div>
  <div v-else-if="error" class="alert alert-secondary mt-4 mb-4" role="alert">
    {{ error }}
  </div>
</template>

<script>
import RecipeCardPopular from "./RecipeCardPopular.vue";
import SimilarArticles from "./SimilarArticles.vue";

export default {
  name: "ArticleOfTheDay",
  components: {
    RecipeCardPopular,
    SimilarArticles, // Register the new component
  },

  props: {
    id: {
      type: Number,
      required: false,
      default: 0,
    },
    articletype: {
      type: String,
      required: false,
      default: "article",
    },
  },

  data() {
    return {
      recipe: null,
      isLoading: true,
      error: null,
    };
  },

  computed: {
    formattedPostText() {
      if (!this.recipe || !this.recipe.posttext) {
        return "<h2>История дня <i class='bi bi-book-half text-info'></i></h2>";
      }

      let content = this.recipe.posttext
        .replace(/(?:\s*#[\p{L}\p{N}_]+)+$/u, "")
        .trim();

      content = content
        .replace(/\*\*(.*?)\*\*/gs, "<strong>$1</strong>")
        .replace(/\*(.*?)\*/gs, "<em>$1</em>")
        .replace(/_(.*?)_/gs, "<em>$1</em>")
        .replace(/\n/g, "<br />");

      return (
        "<p>" +
        content +
        "</p>" +
        "<a href='#/recipes/" +
        this.recipe?.id +
        "'>Посмотреть рецепт</a>"
      );
    },
  },

  async mounted() {
    await this.fetchArticleOfTheDay();
  },

  watch: {
    id() {
      this.fetchArticleOfTheDay();
    },
  },

  methods: {
    async fetchArticleOfTheDay() {
      this.isLoading = true;
      this.error = null;
      try {
        const request =
          this.id > 0
            ? "article.get/" + this.id
            : this.articletype == "article"
            ? "article.getOfTheDay"
            : "recipe.getOfTheDay";
        console.log("ArticleOfTheDay request:", request);
        const response = await this.sendCmd(request);
        this.recipe = JSON.parse(response);
        this.$emit("recipe", this.recipe);
      } catch (err) {
        console.warn("Could not fetch Article:", err);
        this.recipe = null;
        this.error = null;
      } finally {
        this.isLoading = false;
      }
    },

    handleShowFullRecipe(recipe) {
      localStorage.setItem(
        "lastViewedRecipe",
        JSON.stringify({ from: "article-of-the-day", id: recipe.id })
      );
      window.location.hash = `/recipes/${recipe.id}`;
    },
  },
};
</script>
